import { render, staticRenderFns } from "./prePamphlet.vue?vue&type=template&id=2b8739f2&"
import script from "./prePamphlet.vue?vue&type=script&lang=js&"
export * from "./prePamphlet.vue?vue&type=script&lang=js&"
import style0 from "./prePamphlet.vue?vue&type=style&index=0&id=2b8739f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports